<template lang="pug">
.classes__pagination
  .classes__pagination__row(
    v-for="classes_list, id in classesList",
    :key="`pagination-row-${id}`",
  )
    .classes__pagination__archetype(
      :class="{'type-active' : id === selectedArchetype}"
      @click="selectArchetype(id)"
    )
      span {{ $t(`classes.archetypes.${id}`) }}

    .classes__pagination__class(
      v-for="class_item in classes_list",
      :key="`pagination-class-${class_item}`",
      :class="{'type-active' : class_item === selectedClass}",
      @click="selectClass(class_item)"
    )
</template>

<script>
export default {
  name: "ClassesPagination",

  props: {
    selectedArchetype: {
      type: String,
      required: true,
    },
    selectedClass: {
      type: String,
      required: true,
    },
    classesList: {
      type: Object,
      required: true,
    },
  },
  methods: {
    selectArchetype(name) {
      this.$emit("selectArchetype", name);
    },
    selectClass(name) {
      this.$emit("selectClass", name);
    },
  },
};
</script>
